import React, { Component } from "react";
import { _callApiMessage } from "GlobalFunction";
import Input from "@material-ui/core/Input";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";

import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
// @material-ui/icons
import Person from "@material-ui/icons/Person";
import Lock from "@material-ui/icons/Lock";
import Contacts from "@material-ui/icons/Contacts";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import loginPageStyle from "assets/jss/material-kit-react/views/loginPage.jsx";

// core components
function Transition(props) {
  return <Slide direction="up" {...props} />;
}
class LoginPage extends Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden",
      txtId: "",
      txtPw: "",
      openDialog: false,
      autoLogin: false
    };
    this.inputPw = null;
  }
  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    let autologin = localStorage.getItem("autoLogin");
    setTimeout(
      function() {
        this.setState({
          cardAnimaton: ""
        });
      }.bind(this),
      700
    );
    this.setState({ autoLogin: autologin === "true" ? true : false });
    if (autologin) {
      this.setState({
        txtId: localStorage.getItem("SUId") || "",
        txtPw: localStorage.getItem("SUPw") || ""
      });
    }
  }
  handleChange = e => {
    let nextState = {};
    nextState[e.target.name] = e.target.value;
    this.setState(nextState);
  };
  handleSwitchChange = e => {
    this.setState({
      autoLogin: !this.state.autoLogin
    });
  };
  handleLogin = async () => {
    let body = "SUId=" + this.state.txtId + "&SUPw=" + this.state.txtPw;
    let uri = "user/login";
    _callApiMessage(uri, body).then(data => {
      if (data.code === "00") {
        if (data.type === "O") {
          if (data.message === "true") {
            localStorage.setItem("autoLogin", this.state.autoLogin);
            if (this.state.autoLogin) {
              localStorage.setItem("SUId", this.state.txtId);
              localStorage.setItem("SUPw", this.state.txtPw);
            } else {
              localStorage.removeItem("SUId");
              localStorage.removeItem("SUPw");
            }
            this.props.history.push({
              pathname: "/doc",
              state: { detail: data.data }
            });
          } else {
            this.setState({
              openDialog: true,
              loginNotice: "아이디 비밀번호를 확인해주세요"
            });
          }
        }
      } else {
        this.setState({
          openDialog: true,
          loginNotice: "아이디 비밀번호를 확인해주세요"
        });
      }
    });
  };
  handleKeyPress = event => {
    if (event.target.name === "txtId") {
      if (event.key == "Enter") {
        this.inputPw.focus();
      }
    } else if (event.target.name === "txtPw") {
      if (event.key == "Enter") {
        this.handleLogin();
      }
    } else {
      this.setState({ openDialog: false });
    }
  };
  handleClose = () => {
    this.setState({ openDialog: false });
  };
  txtpwRef = ref => {
    this.inputPw = ref;
  };
  onSaveUrl = () => {
    var docUrl = "http://14.63.172.72:8080/DP4/급여박사 바로가기.zip";
    window.open(docUrl);
  };
  render() {
    const { classes, ...rest } = this.props;
    return (
      <div className={classes.container}>
        <Dialog
          open={this.state.openDialog}
          TransitionComponent={Transition}
          keepMounted
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          onKeyPress={this.handleKeyPress}
        >
          <DialogTitle id="alert-dialog-slide-title">{"알림"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {this.state.loginNotice}
            </DialogContentText>
          </DialogContent>
        </Dialog>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={4}>
            <Card className={classes[this.state.cardAnimaton]} card="true">
              <form className={classes.form}>
                <CardHeader color="primary" className={classes.cardHeader}>
                  <p className={classes.loginText}>Login</p>
                  <div className={classes.socialLine} />
                </CardHeader>
                <p className={classes.divider} />
                <CardBody>
                  <CustomInput
                    labelText="ID"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      value: this.state.txtId,
                      type: "text",
                      name: "txtId",
                      endAdornment: (
                        <InputAdornment position="end">
                          <Person className={classes.inputIconsColor} />
                        </InputAdornment>
                      ),
                      onChange: this.handleChange,
                      onKeyPress: this.handleKeyPress
                    }}
                  />
                  <CustomInput
                    labelText="Password"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      inputRef: this.txtpwRef,
                      value: this.state.txtPw,
                      type: "password",
                      name: "txtPw",
                      endAdornment: (
                        <InputAdornment position="end">
                          <Lock className={classes.inputIconsColor} />
                        </InputAdornment>
                      ),
                      onChange: this.handleChange,
                      onKeyPress: this.handleKeyPress
                    }}
                  />
                </CardBody>

                <CardFooter className={classes.cardFooter}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={this.state.autoLogin}
                        onChange={() => this.handleSwitchChange()}
                        value="checkedA"
                        color="default"
                        classes={{
                          switchBase: classes.switchBase,
                          checked: classes.switchChecked,
                          icon: classes.switchIcon,
                          iconChecked: classes.switchIconChecked,
                          bar: classes.switchBar
                        }}
                      />
                    }
                    classes={{
                      label: classes.label
                    }}
                    label="자동 로그인"
                  />
                  <Button
                    color="primary"
                    size="lg"
                    onClick={() => this.handleLogin()}
                  >
                    Login
                  </Button>
                </CardFooter>
              </form>
            </Card>
          </GridItem>
        </GridContainer>
        {/* <div
          id="plusfriend-chat-button"
          data-plusfriend-id="_MJAtj"
          data-title="consult"
          data-size="small"
          data-color="yellow"
          data-shape="pc"
          data-support-multiple-densities="true"
        /> */}
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button onClick={() => this.onSaveUrl()}>바로가기</button>
        </div>
      </div>
    );
  }
}

export default withStyles(loginPageStyle)(LoginPage);
